import React from "react";
import { Link } from "react-router-dom";
import { Trash2 } from "lucide-react";
import Reveal from "../components/ui/Reveal";
import IconBox from "../components/ui/IconBox";
import SEO from "../components/seo/SEO";

export default function AccountDeletionPage() {
  return (
    <>
      <SEO
        title="Account deletion"
        description="How to delete your CampusGenie account and what happens when you do."
        url="/account-deletion"
      />

      <section className="legal-page-hero">
        <div className="container">
          <Reveal>
            <div style={{ display: "flex", justifyContent: "center", marginBottom: "var(--space-4)" }}>
              <IconBox icon={Trash2} size={48} />
            </div>
            <span className="eyebrow">Account</span>
            <h1 className="heading-1" style={{ maxWidth: "18ch", margin: "0 auto 16px" }}>
              Account deletion
            </h1>
            <p className="body-base" style={{ textAlign: "center", maxWidth: "560px", margin: "0 auto" }}>
              Steps to delete your account in the app and what it means for your data.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="section section-sm section-alt">
        <div className="container">
          <Reveal>
            <article className="legal-prose">
              <p className="body-base">To delete your account on CampusGenie, follow these steps:</p>
              <ol className="legal-prose-list legal-prose-list-ol">
                <li>Tap the profile icon in the app.</li>
                <li>
                  Go to <strong>Account &amp; Settings</strong>.
                </li>
                <li>
                  Select <strong>Delete Account</strong>.
                </li>
                <li>Confirm when prompted.</li>
                <li>
                  Tap <strong>Delete</strong> to proceed.
                </li>
              </ol>
              <p className="body-base">
                After you confirm, you will be logged out. Your account will be suspended and permanently deleted within
                about 30 minutes.
              </p>

              <h2 className="heading-4" style={{ marginTop: "var(--space-10)" }}>
                Implications of account deletion
              </h2>
              <p className="body-base">Deleting your account is irreversible. This means:</p>
              <ul className="legal-prose-list">
                <li>Your profile data and preferences will be permanently erased.</li>
                <li>You will lose access to features and services tied to that account.</li>
                <li>Active subscriptions or benefits linked to the account may be canceled.</li>
              </ul>
              <p className="body-base">
                If you need help before deleting your account, download the CampusGenie app and contact support or submit
                a ticket through the app, or visit our{" "}
                <Link to="/contact" className="legal-prose-link">
                  contact page
                </Link>
                .
              </p>
            </article>
          </Reveal>
        </div>
      </section>
    </>
  );
}
